module.exports = __webpack_public_path__ + "static/sk-91a82f452aed1cfc0d02bf969ec4a775.png";